import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import * as Styled from './NetworkBreadCrumbs.style';
import arrowIcon from '../../../../global/media/arrow-breadCrumbs.svg';

interface BreadCrumbsProps {
  editActive: boolean;
}

const NetworkBreadCrumbs = ({ editActive }: BreadCrumbsProps) => {
  const { t } = useTranslation();
  const history = useHistory();

  const handleClick = (push: string) => {
    history.push(push);
  };

  return (
    <Styled.ProductsBreadCrumbsContainer>
      <div className="breadCrumb" onClick={() => handleClick('/sources')}>
        {t('NetworkPage.BREADCRUMBS.PHARMACY_PAGE')}
      </div>
      <Styled.ProductsBreadCrumbIcon>
        <img src={arrowIcon} alt="arrow icon" />
      </Styled.ProductsBreadCrumbIcon>
      <div className="breadCrumb active">
        {editActive
          ? t('NetworkPage.BREADCRUMBS.EDIT_NETWORK')
          : t('NetworkPage.BREADCRUMBS.VIEW_NETWORK')}
      </div>
    </Styled.ProductsBreadCrumbsContainer>
  );
};

export default NetworkBreadCrumbs;
